import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import ReactS3Uploader from "react-s3-uploader";
import { Button } from "../../";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Tooltip } from "@material-ui/core";

var FileUpload = function FileUpload(_ref) {
  var onUploadStart = _ref.onUploadStart,
      signingUrl = _ref.signingUrl,
      s3path = _ref.s3path,
      onUploadFinish = _ref.onUploadFinish,
      uploadInput = _ref.uploadInput,
      server = _ref.server,
      headers = _ref.headers,
      accept = _ref.accept,
      query_params = _ref.query_params,
      variant = _ref.variant,
      title = _ref.title,
      translation = _ref.translation;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      completed = _React$useState2[0],
      setCompleted = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showProgress = _React$useState4[0],
      setShowProgress = _React$useState4[1];

  var _React$useState5 = React.useState(10),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      buffer = _React$useState6[0],
      setBuffer = _React$useState6[1];

  var onUploadProgress = function onUploadProgress(progress) {
    // console.log(progress);
    progress < 100 ? setShowProgress(true) : setShowProgress(false);
    setCompleted(progress);
  };

  var onSignedUrl = function onSignedUrl(url) {// console.log("onSignedUrl", url);
  };

  var onUploadError = function onUploadError(err) {// console.log("onUploadError", err);
  }; // const onUploadStart = err => {
  //   console.log("onUploadStart", err);
  // };
  // console.log("Fileupload", server);


  return [!showProgress && /*#__PURE__*/React.createElement(Tooltip, {
    title: title || ""
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    color: "primary",
    variant: variant || "outlined",
    component: "label"
  }, /*#__PURE__*/React.createElement(ReactS3Uploader, {
    signingUrl: signingUrl,
    signingUrlMethod: "GET",
    accept: accept || "application/x-pkcs12",
    s3path: s3path || "",
    preprocess: onUploadStart,
    onSignedUrl: onSignedUrl,
    onProgress: onUploadProgress,
    onError: onUploadError,
    onFinish: onUploadFinish,
    signingUrlHeaders: {
      additional: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true
      }
    },
    signingUrlQueryParams: {
      additional: query_params
    },
    signingUrlWithCredentials: true // in case when need to pass authentication credentials via CORS
    ,
    uploadRequestHeaders: {
      "x-amz-acl": "public-read"
    } // this is the default
    ,
    contentDisposition: "auto",
    scrubFilename: function scrubFilename(filename) {
      return filename.replace(/[^\w\d_\-.]+/gi, "");
    },
    server: server,
    inputRef: function inputRef(cmp) {
      return uploadInput = cmp;
    },
    autoUpload: true,
    style: {
      display: "none"
    }
  }), translation ? translation.buttons.upload : "Subir archivo")), showProgress && /*#__PURE__*/React.createElement(LinearProgress, {
    variant: "buffer",
    value: completed,
    valueBuffer: buffer
  })];
};

export { FileUpload };